"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _check = _interopRequireDefault(require("../data/check.png"));

var _default = function _default(_ref) {
  var title = _ref.title,
      description = _ref.description;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    src: _check["default"],
    className: "checkmark",
    size: "small"
  }), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "modal-header centered-content"
  }, title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "centered-content body-text blue-color"
  }, description));
};

exports["default"] = _default;